export default __webpack_public_path__ + "static/media/espresso.8fd4a2d6.png";